import React from 'react';

const Autoridade = () => {
  const selos = [
    { texto: "FÓRMULA SEGURA", icon: "🔒", cor: "#5D2E8C" }, 
    { texto: "INGREDIENTES ESSENCIAIS", icon: "🌿", cor: "#32CD32" }, 
    { texto: "SATISFAÇÃO GARANTIDA", icon: "⭐", cor: "#FF8C00" }, 
    { texto: "RESULTADOS COMPROVADOS", icon: "📈", cor: "#5D2E8C" }, 
    { texto: "SAÚDE DIÁRIA", icon: "❤️", cor: "#FF4500" }  
  ];

  return (
    <section style={{padding: '80px 20px', backgroundColor: '#fff', textAlign: 'center'}}>
      <div className="container" style={{maxWidth: '1000px', margin: '0 auto'}}>
        
        {/* ÍCONE VET (Decorativo no topo) */}
        <div style={{fontSize: '3rem', marginBottom: '20px'}}>👨‍⚕️</div>

        {/* TÍTULO */}
        <h2 style={{
          color: '#5D2E8C', 
          fontSize: '2.2rem', 
          fontWeight: '900', 
          marginBottom: '20px', 
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}>
          Aprovada por Veterinários e Tutores
        </h2>

        {/* TEXTO DESCRITIVO */}
        <p style={{
          fontSize: '1.1rem', 
          color: '#555', 
          lineHeight: '1.8', 
          marginBottom: '60px', 
          maxWidth: '800px', 
          margin: '0 auto 60px' // Centraliza o bloco de texto
        }}>
          Cada detalhe da nossa fórmula foi pensado com responsabilidade e critério. 
          O suplemento foi desenvolvido com base em conhecimento técnico, avaliado por 
          veterinários e testado na rotina real de tutores que priorizam saúde, 
          prevenção e bem-estar.
        </p>

        {/* GRID DE SELOS/ÍCONES */}
        <div style={{
          display: 'flex', 
          flexWrap: 'wrap', 
          justifyContent: 'center', 
          gap: '30px'
        }}>
          {selos.map((selo, index) => (
            <div key={index} style={{
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              width: '160px' 
            }}>
              
              {/* Círculo do Ícone */}
              <div style={{
                width: '80px', 
                height: '80px', 
                borderRadius: '50%', 
                backgroundColor: `${selo.cor}15`,
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontSize: '2.5rem',
                marginBottom: '15px',
                border: `2px solid ${selo.cor}`,
                boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
              }}>
                {selo.icon}
              </div>

              {/* Texto do Selo */}
              <h4 style={{
                color: '#333', 
                fontSize: '0.9rem', 
                fontWeight: '800', 
                textTransform: 'uppercase',
                margin: 0,
                lineHeight: '1.4'
              }}>
                {selo.texto}
              </h4>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Autoridade;